
/* NIR.Systems product-page bridge — keeps the Proofroom demo intact. */
(function(){
  var originalWorkspace=null;
  function currentRoute(){
    var h=location.hash||"#/dashboard";
    if(h.indexOf("#/")===0) h=h.slice(2);
    else if(h.charAt(0)==="#") h=h.slice(1);
    var q=h.indexOf("?"); if(q>=0) h=h.slice(0,q);
    return h||"dashboard";
  }
  function emit(){
    try{ parent.postMessage({nir:1,type:"view",view:currentRoute()},"*"); }catch(e){}
  }
  function applyBrand(d){
    var ws=document.querySelector(".ws b"), badge=document.querySelector(".ws .sw");
    if(ws && originalWorkspace===null) originalWorkspace=ws.textContent;
    if(ws) ws.textContent=d.name||originalWorkspace||"Fieldwork Studio";
    if(badge && d.name) badge.textContent=String(d.name).trim().charAt(0).toUpperCase()||"F";
    if(d.color){
      document.documentElement.style.setProperty("--rail",d.color);
      document.documentElement.style.setProperty("--blue",d.color);
    }else{
      document.documentElement.style.removeProperty("--rail");
      document.documentElement.style.removeProperty("--blue");
    }
  }
  addEventListener("message",function(e){
    var d=e.data||{}; if(!d.nir) return;
    if(d.type==="goto" && d.view){
      try{
        if(typeof ROUTES!=="undefined" && ROUTES[d.view] && typeof go==="function") go(d.view);
        else location.hash="#/"+d.view;
      }catch(x){location.hash="#/"+d.view;}
      emit();
    }
    if(d.type==="brand") applyBrand(d);
    if(d.type==="cycle" && d.on && !location.hash) location.hash="#/dashboard";
  });
  addEventListener("hashchange",emit);
  addEventListener("load",emit);
})();
